export interface StorageNavigationState {
  userType: 'starter' | 'artist' | 'studio';
  includesCassetteCloud: boolean;
  driveLinked: boolean;
  storageProvider: string;
  isAnonymous: boolean;
}

export function isExternalStorageLinked(state: StorageNavigationState): boolean {
  const provider = state.storageProvider;
  return state.driveLinked && provider !== 'cassette_s3' && provider !== 'none' && provider !== '';
}

export function requiresExternalStorage(state: StorageNavigationState): boolean {
  return (state.userType === 'artist' || state.userType === 'studio') && !state.includesCassetteCloud;
}

export function isEffectivelyStorageLinked(state: StorageNavigationState): boolean {
  if (state.isAnonymous) {
    return state.storageProvider === 'cassette_s3' || state.driveLinked;
  }
  if (requiresExternalStorage(state)) {
    return isExternalStorageLinked(state);
  }
  return state.driveLinked || state.storageProvider === 'cassette_s3';
}
